import React from 'react';
import { BsFillArrowRightCircleFill } from 'react-icons/bs';
import { useNavigate } from 'react-router-dom';

const Coach = ({ title, data, learning, research, free, id }) => {
    const navigate = useNavigate();
    return (
        <div className={`${learning ? '' : 'mt-5 py-4'}`} id={id}>
            {
                title && <h3 className=' text-slate-400 font-bold lg:text-3xl text-2xl pb-1 border-b-2 border-cyan-600 mb-2'>{title}</h3>
            }
            {
                (!learning && !research) &&
                <div className='px-2'>
                    {
                        !free && <div>
                            <h2 className=' text-lg'>Welcome, I am a certfitied life caoch and relationship counselor. Only one thing is stopping to achieve all your dream is YOU. No one else can divert you from your success if you are commited & dedicated. "If you let go a little, you will have a little peace. If you let go a lot, you will have a lot of peace. If you let go completely, you will have the complete peach". </h2>
                        </div>
                    }
                    <div className={` mt-10 grid lg:grid-cols-3 md:grid-cols-2 grid-cols-1 gap-6`}>
                        {
                            data.map((d, index) => <div key={index} className=' bg-slate-100 rounded p-5 '>
                                <h2 className='text-[#2A1B3D] font-bold text-lg px-2'>{d?.info}</h2>
                                <img className='w-full h-[200px] rounded p-5' src={d?.img} alt="" />
                                <p className={`p-2 ${!free && 'lg:h-[270px] md:h-[240px] xl:h-[230px]'}`}>{d?.des}</p>

                                {
                                    !free && <div className='mt-4  '>
                                        <button onClick={() => { navigate('/coach') }} className=' text-center flex items-center mx-auto justify-center gap-2 bg-cyan-600 rounded  px-5 py-2 text-white '>Know more <BsFillArrowRightCircleFill /></button>
                                    </div>
                                }
                            </div>)
                        }
                    </div>
                </div>
            }

            {
                learning && <div>
                    <div className={`grid lg:grid-cols-3 md:grid-cols-2 grid-cols-1 gap-4 mt-5`}>
                        {
                            data.map((d, index) => <div key={index} className="p-5 rounded bg-slate-100">
                                <h2 className=' text-center text-[#2A1B3D] font-bold text-xl my-2'>{d.name}</h2>
                                <p>{d.para}</p>

                            </div>)
                        }

                    </div>
                </div>
            }

            {
                research && <div>
                    <div className={`grid md:grid-cols-2 grid-cols-1 gap-4`}>
                        {
                            data.map((d, index) => <div key={index} className="p-5 rounded bg-slate-100">
                                <h2 className=' text-center text-[#2A1B3D] font-bold text-xl my-2'>{d.info}</h2>
                                <p className=' text-center'>{d.para}</p>
                                <button onClick={() => { navigate('/research') }} className=' text-center flex items-center mx-auto justify-center gap-2 bg-cyan-600 rounded mt-4 px-5 py-2 text-white'>Know more <BsFillArrowRightCircleFill /></button>
                            </div>)
                        }
                    </div>
                    {/* <div className=' flex justify-center items-center'>
                        <div className='text-[#2A1B3D] mt-10 text-xl font-bold'>
                            <p>*Explore all Research interest <button onClick={() => { navigate('/research') }} className=' text-xs py-1 px-2 bg-head rounded text-white' type="submit">Click here</button></p>
                            <p>*Collaborate with RK <button onClick={() => { navigate('/contact') }} className='mt-1 text-xs py-1 px-2 bg-head rounded text-white' type="submit">Click here</button></p>
                        </div>
                    </div> */}
                </div>
            }


        </div>
    );
};

export default Coach;